var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import 'reflect-metadata';
import { Component, Vue, Watch } from 'vue-property-decorator';
import startCase from 'lodash/startCase';
import Loader from "@/components/loader.vue";
import NotFound from "@/components/notfound.vue";
import AccountCard from "@/components/accountcard.vue";
import * as VuxStore from 'vuex-class';
import BankAccount from './BankAccount/BankAccount.vue';
import { getCompanyLogo } from "../../../lib/utils";
var formatAmount = require("../../../lib/formatAmount").formatAmount;
var Store = VuxStore.namespace('ts');
var Account = /** @class */ (function (_super) {
    __extends(Account, _super);
    function Account() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createReserveModal = false;
        _this.accounts = [];
        _this.activeTab = '';
        _this.formatAmount = formatAmount;
        _this.startCase = startCase;
        _this.makePrimary = '';
        _this.appCount = 'emmsdan';
        return _this;
    }
    Account.prototype.mounted = function () {
        this.fetchReservedAccounts(this.$route.params.id);
        this.commit('setCustomMetaOptions', {
            title: 'Account Insight',
            page: 'Payout',
            info: "Lendqsr"
        });
        this.activeTab = this.$route.hash.replace('#/', '');
    };
    Account.prototype.onAccountSelected = function (account) {
        this.commit('setCustomMetaOptions', {
            title: 'Reserved Account',
            page: 'Account',
            info: "".concat(account.account_name || '', " (").concat(account.account, ")")
        });
        this.$router.push({ name: 'view-reserved-accounts', params: { id: account.id } });
    };
    Account.prototype.onEditAccount = function (account) {
        this.reserved = account;
        this.toggleCreateReserveModal();
    };
    Account.prototype.createAccountModal = function () {
        this.reserved = null;
        this.toggleCreateReserveModal();
    };
    Account.prototype.setAccountAsPrimary = function (account, command) {
        if (command === void 0) { command = null; }
        this.makePrimary = command || account.vnuban_id;
        var account_type = 'BANK';
        if (account.vnuban) {
            account_type = 'VIRTUAL';
        }
        this.createReserve({
            name: account.account_name,
            isPrimary: !command,
            account_id: account.id,
            command: command,
            account_type: account_type
        });
    };
    Object.defineProperty(Account.prototype, "getters", {
        get: function () {
            return this.$store.getters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Account.prototype, "commit", {
        get: function () {
            return this.$store.commit;
        },
        enumerable: false,
        configurable: true
    });
    Account.prototype.toggleCreateReserveModal = function () {
        this.createReserveModal = !this.createReserveModal;
    };
    Account.prototype.getLogo = function (code, defaultValue) {
        if (code === void 0) { code = "any"; }
        if (defaultValue === void 0) { defaultValue = null; }
        return getCompanyLogo(this.getName(code) || defaultValue);
    };
    Account.prototype.getName = function (bank_code) {
        var bank = this.$store.state.bankList.find(function (_a) {
            var code = _a.code, cbn_code = _a.cbn_code;
            return code == bank_code || cbn_code === bank_code;
        });
        return bank ? bank.name || bank.bank : "";
    };
    Account.prototype.getDropdownOptions = function () {
        return [{ value: 'Set as primary', id: 323 }, {}];
    };
    Account.prototype.handleRouteChange = function () {
        this.activeTab = this.$route.hash.replace('#/', '');
    };
    __decorate([
        Store.Getter
    ], Account.prototype, "getReservedAccounts", void 0);
    __decorate([
        Store.Action
    ], Account.prototype, "fetchReservedAccounts", void 0);
    __decorate([
        Store.Action
    ], Account.prototype, "createReserve", void 0);
    __decorate([
        Watch('$route')
    ], Account.prototype, "handleRouteChange", null);
    Account = __decorate([
        Component({
            name: 'Account',
            components: {
                Loader: Loader,
                NotFound: NotFound,
                BankAccount: BankAccount,
                AccountCard: AccountCard,
            },
        })
    ], Account);
    return Account;
}(Vue));
export default Account;
